/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  DeleteAdminV1StoresStoreIdNotificationTemplatesEventPathParameters,
  GetAdminV1StoresStoreIdNotificationTemplates200,
  GetAdminV1StoresStoreIdNotificationTemplatesPathParameters,
  NotificationPreview,
  NotificationTemplate,
  PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody,
  PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewPathParameters,
  PutAdminV1StoresStoreIdNotificationTemplatesEventBody,
  PutAdminV1StoresStoreIdNotificationTemplatesEventPathParameters
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Every shopper email with its default text and the store's override
 */
export const getAdminV1StoresStoreIdNotificationTemplates = (
    { storeId }: GetAdminV1StoresStoreIdNotificationTemplatesPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdNotificationTemplates200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdNotificationTemplates200>(
      {url: `/admin/v1/stores/${storeId}/notification-templates`, method: 'GET'
    },
      options);
    }
  /**
 * Plain text with {{placeholders}} from the event's variable list; one paragraph per line. Unknown placeholders are refused with 422
 * @summary Override the subject or body of an email, or switch it off
 */
export const putAdminV1StoresStoreIdNotificationTemplatesEvent = (
    { storeId, event }: PutAdminV1StoresStoreIdNotificationTemplatesEventPathParameters,
    putAdminV1StoresStoreIdNotificationTemplatesEventBody: BodyType<PutAdminV1StoresStoreIdNotificationTemplatesEventBody>,
 options?: SecondParameter<typeof customInstance<NotificationTemplate>>,) => {
      return customInstance<NotificationTemplate>(
      {url: `/admin/v1/stores/${storeId}/notification-templates/${event}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminV1StoresStoreIdNotificationTemplatesEventBody
    },
      options);
    }
  /**
 * @summary Drop the override and go back to the default
 */
export const deleteAdminV1StoresStoreIdNotificationTemplatesEvent = (
    { storeId, event }: DeleteAdminV1StoresStoreIdNotificationTemplatesEventPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/notification-templates/${event}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Render a draft with sample data
 */
export const postAdminV1StoresStoreIdNotificationTemplatesEventPreview = (
    { storeId, event }: PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewPathParameters,
    postAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody: BodyType<PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody>,
 options?: SecondParameter<typeof customInstance<NotificationPreview>>,) => {
      return customInstance<NotificationPreview>(
      {url: `/admin/v1/stores/${storeId}/notification-templates/${event}/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdNotificationTemplatesEventPreviewBody
    },
      options);
    }
  export type GetAdminV1StoresStoreIdNotificationTemplatesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdNotificationTemplates>>>
export type PutAdminV1StoresStoreIdNotificationTemplatesEventResult = NonNullable<Awaited<ReturnType<typeof putAdminV1StoresStoreIdNotificationTemplatesEvent>>>
export type DeleteAdminV1StoresStoreIdNotificationTemplatesEventResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdNotificationTemplatesEvent>>>
export type PostAdminV1StoresStoreIdNotificationTemplatesEventPreviewResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdNotificationTemplatesEventPreview>>>
